export enum AddressType {
    Shipping,
    Billing,
    Default="Select billing or shipping address"
}